import React, { useState, useEffect } from 'react';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';

export const TimerSubOneActFour = ({ action = () => { } }) => {
	const [timerView, setTimerView] = useState('0:00');
	let segundos = 59;
	let minutos = 0;
	let timeoutId;

	const iniciarCronometro = (isFinish = false) => {
		if (isFinish) {
			console.log('acabo');
			return;
		}

		const cronometro = `${minutos}.${segundos < 10 ? '0' : ''}${segundos}`;
		setTimerView(cronometro);

		if (segundos === 0) {
			minutos--;
			segundos = 59;
		} else {
			segundos--;
		}

		if (segundos === 0 && minutos === 0) {
			console.log('Tiempo finalizado');
			action();
			return;
		}

		timeoutId = setTimeout(iniciarCronometro, 1000); // Almacena el identificador del temporizador
	};

	useEffect(() => {
		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.openClock, (active = true) => {
			if (active) {
				iniciarCronometro();
			} else {
				// Detener el temporizador si no está activo
				clearTimeout(timeoutId);
			}
		});

		// Limpia el temporizador al desmontar el componente
		return () => clearTimeout(timeoutId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [action, timeoutId]);

	return (
		<div className="fixed bg-[#000000a4] z-30  bottom-[120px] md:bottom-[200px] left-4 h-[48px] w-[160px] md:h-[64px] md:w-[235px] flex justify-center items-center flex-col rounded-[16px]">
			<span className="text-gray-400 text-[10px] md:text-[14px]">Tiempo restante</span>
			<span className="text-white text-[10px] md:text-[24px]">{timerView}</span>
		</div>
	);
};
